<template>
    <div class='body'>
        <div class='search-box'>
            <div class='search-box-line'>
                <span class='title' v-html="'&emsp;&emsp;年级：'"></span>
                <el-date-picker
                    v-model='searchGrade'
                    type='year'
                    class='filter-input'
                    value-format='yyyy'
                    placeholder='请选择选择年级'
                    :clearable='false'
                >
                </el-date-picker>
                <span class='title' v-html="'&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&nbsp;&nbsp;专业：'"></span>
                <el-select
                    class='filter-input'
                    filterable
                    clearable
                    v-model='searchMajor'
                    placeholder='请选择专业'
                >
                    <el-option
                        v-for='item in major'
                        :key='item.value'
                        :label='item.label.split(" ")[2]'
                        :value='item.value'
                        v-if='item.label.split(" ")[0] === getDateYear(searchGrade)'
                    ></el-option>
                </el-select>
                <span class='title' v-html="'&emsp;&emsp;学期：'"></span>
                <el-select
                    class='filter-input margin-right-clear'
                    clearable
                    v-model='searchSemester'
                    placeholder='请选择学期'
                >
                    <el-option
                        v-for='item in semester'
                        :key='item.value'
                        :label='item.label'
                        :value='item.value'
                    ></el-option>
                </el-select>
                <div class='margin-left-30'>
                    <el-button
                        class='primary-btn'
                        @click='reset()'
                    >重置
                    </el-button>
                    <el-button
                        type='primary'
                        style='margin-left: 16px'
                        @click='getData(1)'
                    >查询
                    </el-button>
                    <el-button
                        type='text'
                        @click='handleIsShow'
                    >
                        {{ this.isShowText }}
                        <i
                            class='el-icon-arrow-down'
                            v-show='!isShow'
                        ></i>
                        <i
                            class='el-icon-arrow-up'
                            v-show='isShow'
                        ></i>

                    </el-button>
                </div>
            </div>
            <div
                v-if='isShow'
                class='search-box-line'
                style='margin-top: 20px'
            >
                <span class='title'>函授站点：</span>
                <el-select
                    class='filter-input'
                    filterable
                    clearable
                    v-model='station'
                    placeholder='请选择函授站点'
                >
                    <el-option
                        v-for='item in stations'
                        :key='item.value'
                        :label='item.label'
                        :value='item.value'
                    ></el-option>
                </el-select>
                <span class='title'>姓名/手机号/身份证：</span>
                <el-input
                    class='filter-input'
                    filterable
                    clearable
                    v-model='searchContent'
                    placeholder='请输入姓名/手机号/身份证'
                >
                </el-input>
                <span class='title' style='display: none'>签到状态：</span>
                <el-select
                        class='filter-input'
                        filterable
                        clearable
                        v-model='is_sign'
                        placeholder='请选择签到状态'
                        style='display: none'
                >
                    <el-option
                            v-for='item in signSelect'
                            :key='item.value'
                            :label='item.label'
                            :value='item.value'
                    ></el-option>
                </el-select>
            </div>
        </div>
        <div class='container'>
            <div class='container-btn-line'>
                <el-button
                    type='primary'
                    @click='exportStuAllScore'
                >批量导出学生成绩
                </el-button>
                <el-button
                    type='primary'
                    @click='showProgress'
                >查看进度
                </el-button>
                <el-button
                    v-if='modify_flag'
                    type='primary'
                    @click='batch'
                >批量修改学生成绩
                </el-button>
                <el-button
                    type='primary'
                    @click='exportStuAllSign'
                >批量导出签到记录
                </el-button>
                <el-button
                    type='primary'
                    @click='Importoflien'
                >导入线下成绩
                </el-button>
                <el-button
                    type='primary'
                    @click='downloadImportTemp'
                >下载导入模板
                </el-button>
            </div>
            <div class='table-cls'>
                <el-table
                    :data='tableData'
                    :span-method='spanMethod'
                    v-loading="loading"
                    class='table'
                    border
                    style='font-size: 14px'
                    :cell-style="{ color: '#666666' }"
                    :header-cell-style="{ background: '#eef1f6', color: '#333333', height: '49px', fontWeight: 500 }"
                >
                    <!--                  <el-table-column prop="id" align="center" label="ID"></el-table-column>-->

                    <el-table-column
                        prop='grade'
                        align='center'
                        label='年级'
                    ></el-table-column>
                    <el-table-column
                        prop='name'
                        align='center'
                        label='姓名'
                    ></el-table-column>
                    <el-table-column
                        prop='major_id'
                        align='center'
                        label='专业'
                    >
                        <template slot-scope='scope'>
                            {{ tableMajorHash[scope.row.major_id] }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop='level'
                        align='center'
                        label='层次'
                    ></el-table-column>
                    <el-table-column
                        prop='station'
                        align='center'
                        label='函授站点'
                    ></el-table-column>

                    <el-table-column
                        prop='semester'
                        align='center'
                        label='学期'
                    >
                        <template slot-scope='scope'>
                            {{ semesterHash[scope.row.semester] }}

                        </template>
                    </el-table-column>

                    <el-table-column
                        prop='crs_id'
                        align='center'
                        width='230px'
                        label='课程'
                    >
                        <template slot-scope='scope'>
                            {{ scope.row.other_name==''?crsDataHash[scope.row.crs_id]:scope.row.other_name }}
                        </template>
                    </el-table-column>

                    <el-table-column
                            prop='is_sign'
                            align='center'
                            width='100px'
                            label='签到状态'
                    >
                        <template slot-scope='scope'>
                            <span v-if="scope.row.is_sign === 0" style="color: #F56C6C">
                                {{ issige[scope.row.crs_id] === 8?'':'未签到' }}
                            </span>
                            <span v-if="scope.row.is_sign === 1" style="color: #409EFF">已签到</span>
                            <span v-if="scope.row.is_sign === ''"></span>
<!--                            {{ scope.row.is_sign }}-->
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop='sign_time'
                            align='center'
                            width='180px'
                            label='签到时间'
                    >
                        <template slot-scope='scope'>
                            {{ scope.row.sign_time }}
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop='video_score'
                        align='center'
                        label='视频成绩'
                    >
                        <template slot-scope='scope'>

                            <div v-if='modify_flag'>

                                <el-input

                                    v-if="scope.row.crs_id!=''"
                                    @focus='focus($event)'
                                    @blur=' blur($event)'
                                    :readonly='isbatchShow'
                                    @dblclick.native='dblclick()'
                                    oninput="value=value.replace(/[^0-9]/g,'')"
                                    :max='100'
                                    :min='0'
                                    v-model='scope.row.video_score'

                                ></el-input>

                            </div>
                            <div v-else> {{ issige[scope.row.crs_id] === 8?'':scope.row.video_score }}</div>

                        </template>
                    </el-table-column>
                    <el-table-column
                        prop='homework_score'
                        align='center'
                        label='作业成绩'
                    >
                        <template slot-scope='scope'>
                            <div v-if='modify_flag'>
                                <el-input
                                    v-if="scope.row.crs_id!=''"
                                    :readonly='isbatchShow'
                                    @focus='focus($event)'
                                    @blur=' blur($event)'
                                    oninput="value=value.replace(/[^0-9]/g,'')"
                                    :max='100'
                                    v-model='scope.row.homework_score'
                                    @dblclick.native='dblclick()'
                                ></el-input>
                            </div>
                            <div v-else> {{ issige[scope.row.crs_id] === 8?'':scope.row.homework_score }}</div>


                        </template>
                    </el-table-column>
                    <el-table-column
                        prop='test_score'
                        align='center'
                        label='考试成绩'
                    >
                        <template slot-scope='scope'>


                            <div v-if='modify_flag'>
                                <el-input
                                    v-if="scope.row.crs_id!=''"
                                    :readonly='isbatchShow'
                                    @dblclick.native='dblclick()'
                                    @focus='focus($event)'
                                    @blur=' blur($event)'
                                    oninput="value=value.replace(/[^0-9]/g,'')"
                                    :max='100'
                                    v-model='scope.row.test_score'
                                ></el-input>


                            </div>
                            <div v-else> {{ issige[scope.row.crs_id] === 8?'':scope.row.test_score }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop='offline_score'
                        align='center'
                        label='线下成绩'
                    >
                        <template slot-scope='scope'>

                            <div v-if='scope.row.crs_id == 493'>
                                <div>
                                    及格
                                </div>
                            </div>

                            <div v-else
                                >
                                {{ scope.row.offline_score }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop='total'
                        align='center'
                        label='总分'
                    >
                        <template slot-scope='scope'>

                            <div v-if='scope.row.crs_id == 493'>
                                <div
                                    class="color-green">
                                    及格
                                </div>
                            </div>

                            <div v-else
                                :class="scope.row.total>=60?scope.row.total<=80?'color-green':'color-blue':'color-red'">
                                {{ scope.row.total }}
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class='pagination'>
                <el-pagination
                    background
                    layout='total, prev, pager, next'
                    :current-page='pageIndex'
                    :page-size='2'
                    :total='pageTotal'
                    @current-change='handlePageChange'
                ></el-pagination>
            </div>
        </div>

        <!-- 批量修改学生成绩 -->
        <el-dialog
            title='批量修改学生成绩'
            :visible.sync='batchShow'
            width='50%'
            :close-on-click-modal='false'
        >
            <el-form
                :model='ruleForm'
                :rules='rules'
                ref='ruleForm'
                label-width='100px'
                class='demo-ruleForm'
            >

                <div> 条件：</div>
                <el-form-item
                    label='年级'
                    prop='grade'
                >
                    <el-date-picker
                        v-model='ruleForm.grade'
                        type='year'
                        placeholder='请选择年级'
                        format='yyyy'
                        value-format='yyyy'
                        style='width: 240px'
                    >
                    </el-date-picker>
                </el-form-item>

                <el-form-item
                    label='学期'
                    prop='semester_id'
                >
                    <el-select
                        class='search-input'
                        filterable
                        style='width: 240px'
                        clearable
                        v-model='ruleForm.semester_id'
                        placeholder='请选择学期'
                    >
                        <el-option
                            v-for='item in semesters'
                            :key='item.value'
                            :label='item.label'
                            :value='item.value'
                        ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item
                    label='专业'
                    prop='region'
                >
                    <el-select
                        v-model='ruleForm.major_id'
                        filterable
                        clearable
                        style='width: 240px'
                        placeholder='请选择专业'
                    >
                        <el-option
                            v-for='item in majorList'
                            :key='item.value'
                            :label='item.label'
                            :value='item.value'
                        >
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label='函授站点'>
                    <el-select
                        class='search-input'
                        filterable
                        clearable
                        style='width: 240px'
                        v-model='ruleForm.station_id'
                        placeholder='请选择函授站点'
                    >
                        <el-option
                            v-for='item in stations'
                            :key='item.value'
                            :label='item.label'
                            :value='item.value'
                        ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item
                    label='视频成绩'
                    prop='region'
                >

                    <div class='df'>

                        <div :style="{'width':'150px'}">
                            <el-select
                                class='search-input'
                                filterable
                                clearable
                                v-model='ruleForm.video_condition[0]'
                                placeholder='请选择范围'
                                @change='isVC(ruleForm.video_condition[0])'
                            >
                                <el-option
                                    v-for='item in homeworks'
                                    :key='item.value'
                                    :label='item.label'
                                    :value='item.value'
                                ></el-option>
                            </el-select>
                        </div>

                        <div class='df1'>

                            <el-input-number
                                v-model='ruleForm.video_condition[1]'
                                :min='isVMin'
                                :max='isVMax'
                                :disabled='isVD'
                                @change='isVCdata1(ruleForm.video_condition[1])'
                                label='描述文字'
                            ></el-input-number>

                            <div class='lien'>至</div>

                            <el-input-number
                                v-model='ruleForm.video_condition[2]'
                                :min='isVMin2'
                                :max='isVMax2'
                                :disabled='isVD2'
                                label='描述文字'
                            ></el-input-number>

                        </div>

                    </div>

                </el-form-item>

                <el-form-item
                    label='作业成绩'
                    prop='region'
                >

                    <div class='df'>

                        <div :style="{'width':'150px'}">
                            <el-select
                                class='search-input'
                                filterable
                                clearable
                                @change='isZC(ruleForm.homework_condition[0])'
                                v-model='ruleForm.homework_condition[0]'
                                placeholder='请选择范围'
                            >
                                <el-option
                                    v-for='item in tests'
                                    :key='item.value'
                                    :label='item.label'
                                    :value='item.value'
                                ></el-option>
                            </el-select>
                        </div>

                        <div class='df1'>
                            <el-input-number
                                v-model='ruleForm.homework_condition[1]'
                                :min='isZMin'
                                :max='isZMax'
                                :disabled='isZD'
                                @change='isZCdata1(ruleForm.homework_condition[1])'
                                label='描述文字'
                            ></el-input-number>
                            <div class='lien'>至</div>
                            <el-input-number
                                v-model='ruleForm.homework_condition[2]'
                                :min='isZMin2'
                                :max='isZMax2'
                                :disabled='isZD2'
                                label='描述文字'
                            ></el-input-number>
                        </div>

                    </div>

                </el-form-item>

                <el-form-item
                    label='考试成绩'
                    prop='region'
                >

                    <div class='df'>

                        <div :style="{'width':'150px'}">
                            <el-select
                                class='search-input'
                                filterable
                                clearable
                                @change='isKC(ruleForm.test_condition[0])'
                                v-model='ruleForm.test_condition[0]'
                                placeholder='请选择范围'
                            >
                                <el-option
                                    v-for='item in tests'
                                    :key='item.value'
                                    :label='item.label'
                                    :value='item.value'
                                ></el-option>
                            </el-select>
                        </div>

                        <div class='df1'>
                            <el-input-number
                                v-model='ruleForm.test_condition[1]'
                                :min='isKMin'
                                :max='isKMax'
                                :disabled='isKD'
                                @change='isKCdata1(ruleForm.test_condition[1])'
                                label='描述文字'
                            ></el-input-number>
                            <div class='lien'>至</div>
                            <el-input-number
                                v-model='ruleForm.test_condition[2]'
                                :min='isKMin2'
                                :max='isKMax2'
                                :disabled='isKD2'
                                label='描述文字'
                            ></el-input-number>
                        </div>

                    </div>

                </el-form-item>
                <el-divider></el-divider>

                <div :style="{'margin':'20px 0'}"> 修改后成绩范围：</div>

                <el-form-item
                    label='视频成绩'
                    prop='region'
                >

                    <div class='df2'>
                        <el-input-number
                            v-model='ruleForm.video_scores[0]'
                            :min='VMin'
                            :max='VMax'
                            @change='Vchange(ruleForm.video_scores[0])'
                            label='描述文字'
                            :disabled='VIMin'
                        ></el-input-number>
                        <div class='lien'>至</div>
                        <el-input-number
                            v-model='ruleForm.video_scores[1]'
                            :min='VMin2'
                            :max='VMax2'
                            label='描述文字'
                            :disabled='VIMax'
                        ></el-input-number>
                    </div>
                </el-form-item>

                <el-form-item
                    label='作业成绩'
                    prop='region'
                >

                    <div class='df2'>
                        <el-input-number
                            v-model='ruleForm.homework_scores[0]'
                            :min='ZMin'
                            :max='ZMax'
                            :disabled='ZIMin'
                            @change='Zchange(ruleForm.homework_scores[0])'
                            label='描述文字'
                        ></el-input-number>
                        <div class='lien'>至</div>
                        <el-input-number
                            v-model='ruleForm.homework_scores[1]'
                            :min='ZMin2'
                            :max='ZMax2'
                            :disabled='ZIMax'
                            label='描述文字'
                        ></el-input-number>
                    </div>
                </el-form-item>

                <el-form-item
                    label='考试成绩'
                    prop='region'
                >

                    <div class='df2'>
                        <el-input-number
                            v-model='ruleForm.test_scores[0]'
                            :min='KMin'
                            :max='KMax'
                            :disabled='KIMin'
                            @change='Kchange(ruleForm.test_scores[0])'
                            label='描述文字'
                        ></el-input-number>
                        <div class='lien'>至</div>
                        <el-input-number
                            v-model='ruleForm.test_scores[1]'
                            :min='KMin2'
                            :max='KMax2'
                            :disabled='KIMax'
                            label='描述文字'
                        ></el-input-number>
                    </div>
                </el-form-item>

                <el-form-item>
                    <div class='model-bom'>

                        <el-button @click='batchShow=false'>取消</el-button>
                        <el-button
                            type='primary'
                            @click="submitForm('ruleForm')"
                        >确定
                        </el-button>
                    </div>
                </el-form-item>
            </el-form>

        </el-dialog>

        <!-- 批量修改学生成绩 -->
        <el-dialog
            title='再次确认信息'
            :visible.sync='batchShow1'
            width='50%'
            :close-on-click-modal='false'
        >

            <div class='left-model'>条件</div>
            <div
                v-if="ruleForm.grade!=''"
                class='mot'
            >年级：{{ ruleForm.grade }}
            </div>

            <div
                v-if="ruleForm.semester_id!=''"
                class='mot'
            >学期：{{ semesterId(ruleForm.semester_id) }}
            </div>
            <div
                v-if="ruleForm.major_id!=''"
                class='mot'
            >专业：{{ majorId(ruleForm.major_id) }}
            </div>
            <div
                v-if="ruleForm.station_id!=''"
                class='mot'
            >
                函授站点：{{ stationId(ruleForm.station_id) }}
                <!-- 函授站点：{{ ruleForm.station_id }} -->
            </div>

            <div
                v-if="ruleForm.video_condition[0]!=''"
                class='mot motV'
            >视频成绩：{{ isRange(ruleForm.video_condition) }}
            </div>
            <div
                v-if="ruleForm.homework_condition[0]!=''"
                class='mot motZ'
            >作业成绩：{{ isRange(ruleForm.homework_condition) }}
            </div>
            <div
                v-if="ruleForm.test_condition[0]!=''"
                class='mot motK'
            >考试成绩：{{ isRange(ruleForm.test_condition) }}
            </div>


            <el-divider></el-divider>

            <div class='left-model'>修改成绩</div>

            <div
                v-if="ruleForm.video_condition[0]!=''"
                class='mot motV'
            >视频成绩：{{ ruleForm.video_scores[0] }}~{{ ruleForm.video_scores[1] }}
            </div>
            <div
                v-if="ruleForm.homework_condition[0]!=''"
                class='mot motZ'
            >作业成绩：{{ ruleForm.homework_scores[0] }}~{{ ruleForm.homework_scores[1] }}
            </div>
            <div
                v-if="ruleForm.test_condition[0]!=''"
                class='mot motK'
            >考试成绩：{{ ruleForm.test_scores[0] }}~{{ ruleForm.test_scores[1] }}
            </div>

            <div class='df3'>
                <el-button @click='batchShow1=false'>取消</el-button>
                <el-button
                    type='primary'
                    @click='submitForm1()'
                >确定
                </el-button>
            </div>
        </el-dialog>


        <el-dialog title='导入学生线下成绩' :visible.sync="importVisible" width="638px"
                   :close-on-click-modal='false' :close-on-press-escape='false'>
            <el-form :rules="rules">
                <el-form-item class="form-item" label-width="100px" label="学生成绩：" prop="excel">
                    <el-upload
                        class="upload-demo"
                        ref="upload"
                        drag
                        :action=this.FILE_TEMP_URL
                        :file-list="fileList"
                        :limit=1
                        :before-upload="onBeforeUpload"
                        :on-success="onSuccessUpload"
                        :on-remove="onRemoveUpload"
                        multiple
                    >
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>

                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
		        <el-button @click="closeImport">取 消</el-button>
		        <el-button type="primary" @click="saveImport">确 定</el-button>
		    </span>
        </el-dialog>
    </div>
</template>

<script>
import TemplatePage from '@/pages/Arrangement/Arrangement';
import { isBlank } from '../../utils/util';

export default {
    name: 'StudentResult',
    components: { TemplatePage },
    data() {
        return {
            importVisible:false,
            modify_flag: true,
            is_sign: '',    // 签到状态
            signSelect:[
                {
                    value: 0,
                    label: '未签到'
                },
                {
                    value: 1,
                    label: '已签到'
                }
            ],

            tableMajorHash: [],
            isShowText: '展开',
            isShow: false,
            stations: [],
            stationsHash: [],
            accountOrg: 0,
            orgHash: [],
            crsDataHash: [],
            issige:[],
            searchGrade: new Date(),
            searchMajor: '',
            searchSemester: '',
            searchContent: '',
            station: '',
            pageIndex: 1,
            pageSize: 10,
            pageTotal: 0,
            tableData: [],
            major: [],
            fileList:[],
            majorHash: [],
            semester: [],
            semesterHash: [],
            array: {
                name: [],
                semester: []
            },

            /*批量 */

            /************************************* */
            batchShow1: false,
            isVMin: 0,
            isVMax: 100,
            isVD: true,

            isVMin2: 0,
            isVMax2: 100,
            isVD2: true,

            isZMin: 0,
            isZMax: 100,
            isZD: true,

            isZMin2: 0,
            isZMax2: 100,
            isZD2: true,

            isKMin: 0,
            isKMax: 100,
            isKD: true,

            isKMin2: 0,
            isKMax2: 100,
            isKD2: true,

            /*结果 */

            VMin: 0,
            VMax: 100,
            VMin2: 0,
            VMax2: 100,

            VIMin: true,
            VIMax: true,

            ZMin: 0,
            ZMax: 100,
            ZMin2: 0,
            ZMax2: 100,

            ZIMin: true,
            ZIMax: true,

            KMin: 0,
            KMax: 100,
            KMin2: 0,
            KMax2: 100,

            KIMin: true,
            KIMax: true,

            semesters: [
                {
                    value: '1',
                    label: '第一学期'
                },
                {
                    value: '2',
                    label: '第二学期'
                },
                {
                    value: '3',
                    label: '第三学期'
                },
                {
                    value: '4',
                    label: '第四学期'
                },
                {
                    value: '5',
                    label: '第五学期'
                },
                {
                    value: '6',
                    label: '第六学期'
                }
            ], //学期
            majorList: [], //专业下拉

            loading: false,
            //视频城建条件
            videos: [
                {
                    value: '大于等于',
                    label: '大于等于'
                },
                {
                    value: '介于',
                    label: '介于'
                },
                {
                    value: '小于等于',
                    label: '小于等于'
                }
            ],
            //作业城建条件
            homeworks: [
                {
                    value: '大于等于',
                    label: '大于等于'
                },
                {
                    value: '介于',
                    label: '介于'
                },
                {
                    value: '小于等于',
                    label: '小于等于'
                }
            ],
            //考试城建条件
            tests: [
                {
                    value: '大于等于',
                    label: '大于等于'
                },
                {
                    value: '介于',
                    label: '介于'
                },
                {
                    value: '小于等于',
                    label: '小于等于'
                }
            ],

            isbatchShow: true,
            batchShow: false,
            ruleForm: {
                grade: '', //年级
                semester_id: '', //学期
                major_id: '', //专业
                station_id: '', //函授站

                video_condition: ['', 0, 0], //条件-视频成绩
                homework_condition: ['', 0, 0], //条件-作业成绩
                test_condition: ['', 0, 0], //条件-考试成绩

                video_scores: [], //视频成绩
                homework_scores: [], //作业成绩
                test_scores: [] //考试成绩
            },
            rules: {
                grade: [{ required: true, message: '请选择年级', trigger: 'change' }],
                semester_id: [{ required: true, message: '请选择学期', trigger: 'change' }]
                // major_id: [{ required: true, message: '请选择活动区域', trigger: 'change' }],
                // station_id: [{ required: true, message: '请选择活动区域', trigger: 'change' }]
            }
        };
    },

    created() {
        var modify_flagbef = localStorage.getItem('modify_flag');
        if (modify_flagbef == 'true') {
            this.modify_flag = true;

        } else {
            this.modify_flag = true;
        }
        this.accountOrg = localStorage.getItem('org');
        this.getData(1);
        this.getTblInfo();
        this.getTransitionValue();
        this.getCrsData();
    },
    mounted() {
        this.initData();
    },
    methods: {
        //函授站点
        stationId(id) {

            var val = '';

            this.stations.forEach((item) => {
                if (id == item.value) {
                    val = item.label;
                }
            });
            return val;

        },
        //学期
        semesterId(id) {
            var val = '';

            this.semester.forEach((item) => {
                if (id == item.value) {
                    val = item.label;
                }
            });
            return val;
        },
        //专业
        majorId(id) {
            var val = '';

            this.majorList.forEach((item) => {
                if (id == item.value) {
                    val = item.label;
                }
            });
            return val;
        },

        isRange(item) {
            var val = '';
            if (item[0] == '介于') {

                val = item[0] + '  ' + item[1] + ' ~ ' + item[2];
            } else if (item[0] == '大于等于') {
                val = item[0] + '  ' + ' ≧ ' + item[1];

            } else {
                val = item[0] + '  ' + ' ≦ ' + item[1];
            }


            return val;

        },

        // 批量导出学生成绩按钮事件
        exportStuAllScore() {
            let year = this.getDateYear(this.searchGrade);
            this.$post(this.BASEURL + '/achievement/export/list/all', {
                grade: parseInt(year),
                major_id: this.searchMajor,
                semester: this.searchSemester,
                station_id: this.station,
                content: this.searchContent
            }).then((res) => {
                if (res.code === 200) {
                    this.$message.success(res.msg);
                    // window.open(res.file_url)
                } else {
                    this.$message.error(res.error);
                }
            });
        },
        // 批量导出学生签到按钮事件
        exportStuAllSign() {
            let year = this.getDateYear(this.searchGrade);
            this.$post(this.BASEURL + '/achievement/export/sign', {
                grade: parseInt(year),
                major_id: this.searchMajor,
                semester: this.searchSemester,
                station_id: this.station,
                content: this.searchContent,
                is_sign: this.is_sign
            }).then((res) => {
                if (res.code === 200) {
                    this.$message.success(res.msg);
                    // window.open(res.file_url)
                } else {
                    this.$message.error(res.error);
                }
            });
        },
        // 查看进度按钮事件
        showProgress() {
            this.$router.push({ path: '/task' });
        },
        handleIsShow() {
            this.isShow = !this.isShow;
            this.isShow === false ? (this.isShowText = '展开') : (this.isShowText = '收起');
        },
        // 获取字符串的年份
        getDateYear(val) {
            if (typeof val == 'object') {
                return val.getFullYear() + '';
            }
            return val + '';
        },
        //处理数据方便表格合并
        detail(name) {
            let array = [];
            let row = 0;
            array.push(0);
            if (this.tableData.length == 1) array[0] = 1;
            for (let i = 1; i < this.tableData.length; i++) {
                array.push(0);
                // 判断是否与上个数据相同
                if (this.tableData[i][name] != this.tableData[i - 1][name]) {
                    array[row] = i - row;
                    row = i;
                    if (name == 'semester' && this.tableData[i]['id'] != this.tableData[i - 1]['id']) {
                        array[i] = 1;
                        continue;
                    }
                    if (i == this.tableData.length - 1) array[i] = 1;

                } else if (i + 1 == this.tableData.length) {
                    array[row] = i + 1 - row;
                    if (name == 'semester' && this.tableData[i]['id'] != this.tableData[i - 1]['id']) {
                        array[row] = i - row;
                        array[i] = 1;
                    }
                }
            }
            this.array[name] = array;
        },
        //表格合并
        spanMethod({ row, column, rowIndex, columnIndex }) {
            // [7, 0, 0, 0, 0, 0, 0, 5, 0, 0, 0, 0
            if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 3 || columnIndex === 4) {
                if (this.array['id'][rowIndex] > 0) {
                    return {
                        rowspan: this.array['id'][rowIndex],
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
            if (columnIndex === 5) {
                if (this.array['semester'][rowIndex] > 0) {
                    return {
                        rowspan: this.array['semester'][rowIndex],
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
        },
        //获取课程列表
        getCrsData() {
            this.$get(this.BASEURL + '/tution/course/GET').then((res) => {
                if (res.code === 200) {
                    let hash = [], issign = [];
                    res.crsData.forEach((item, index) => {
                        hash[item.id] = item.name + item.cls_name;
                        issign[item.id] = item.cls_id
                    });
                    this.crsDataHash = hash;
                    this.issige = issign;
                } else {
                    console.log(res.error);
                }
                console.log(this.crsDataHash)
            });
        },
        //获取列表数据
        getData(page) {
            let grade = this.searchGrade;
            if (typeof grade == 'object') grade = grade.getFullYear();
            this.loading = true
            this.pageIndex = page;
            this.$get(
                this.BASEURL +
                `/achievement/result/list/all?grade=${grade}&page=${page}&major_id=${
                    this.searchMajor}&semester=${this.searchSemester}&station_id=${
                    this.station}&content=${this.searchContent}&is_sign=${this.is_sign}`
            ).then((res) => {
                this.loading = false
                if (res.code === 200) {
                    this.tableData = res.data;

                    for (let i = 0; i < this.tableData.length; i++) {
                        this.tableData[i]['isShow2'] = true;
                    }

                    this.pageTotal = res.total;
                    this.detail('id');
                    this.detail('semester');
                } else {
                    console.log(res.error);
                }
            });
        },
        getTblInfo() {
            this.$post(this.BASEURL + '/assets/table/info', {
                tbl_list: [
                    ['id', 'grade,level,name', 'major_base_t'],
                    ['org', 'org_name', 'academy_base_t'],
                    ['id', 'name', 'station_base_t'],
                    ['id', 'name', 'major_base_t']
                ],
                state: 1
            }).then((res) => {
                if (res.code === 200) {
                    this.major = res.data[0][0];
                    this.majorHash = res.data[0][1];
                    this.orgHash = res.data[1][1];
                    this.stations = res.data[2][0];
                    this.stationsHash = res.data[2][1];
                    this.tableMajorHash = res.data[3][1];
                } else {
                    console.log(res.error);
                }
            });
        },
        getTransitionValue() {
            let data = ['major_semester'];
            this.$post(this.BASEURL + '/assets/transition/GET', {
                key_list: data
            }).then((res) => {
                if (res.code === 200) {
                    this.semester = res.data.major_semester[0];
                    this.semesterHash = res.data.major_semester[1];
                } else {
                    console.log(res.error);
                }
            });
        },
        handlePageChange(val) {
            this.pageIndex = val;
            this.getData(this.pageIndex);
        },
        reset() {
            this.searchGrade = new Date();
            this.searchMajor = '';
            this.searchSemester = '';
            this.searchContent = '';
            this.getData(1);
        },

        /*********批量****************************************************** */


        //考试
        ErBlur(row) {
            var pamas = {
                phone: row.phone,
                semester_id: row.semester_id,
                crs_id: row.crs_id,
                test_score: parseInt(row.test_score)
            };

            this.$post(this.BASEURL + '/achievement/modify/student/score', pamas).then((res) => {
                if (res.code === 200) {
                    this.$message.success(res.msg);
                } else {
                    this.$message.error(res.error);
                }
                this.getData(1);
            });
        },
        //作业
        ZyBlur(row) {

            var pamas = {
                phone: row.phone,
                semester_id: row.semester_id,
                crs_id: row.crs_id,
                homework_score: parseInt(row.homework_score)
            };

            this.$post(this.BASEURL + '/achievement/modify/student/score', pamas).then((res) => {
                if (res.code === 200) {
                    this.$message.success(res.msg);
                } else {
                    this.$message.error(res.error);
                }
                this.getData(1);
            });
        },
        //视频
        SpBlur(row) {

            var pamas = {
                phone: row.phone,
                semester_id: row.semester_id,
                crs_id: row.crs_id,
                video_score: parseInt(row.video_score)
            };

            this.$post(this.BASEURL + '/achievement/modify/student/score', pamas).then((res) => {
                if (res.code === 200) {
                    this.$message.success(res.msg);
                } else {
                    this.$message.error(res.error);
                }
                this.getData(1);
            });
        },
        ckV(row) {
            row.isShow = false;
        },

        /**批量修改学生成绩 */
        batch() {
            this.batchShow = true;
        },
        submitForm1() {
            this.ruleForm.major_id = this.ruleForm.major_id == '' ? null : this.ruleForm.major_id;
            this.ruleForm.station_id = this.ruleForm.station_id == '' ? null : this.ruleForm.station_id;

            //    video_condition: ['', 0, 0], //条件-视频成绩
            //     homework_condition: ['', 0, 0], //条件-作业成绩
            //     test_condition: ['', 0, 0], //条件-考试成绩

            this.ruleForm.video_scores =
                this.ruleForm.video_condition[0] == '' ? [] : this.ruleForm.video_scores[0] == undefined ? [] : this.ruleForm.video_scores;
            this.ruleForm.homework_scores =
                this.ruleForm.homework_condition[0] == ''
                    ? []
                    : this.ruleForm.homework_scores[0] == undefined
                    ? []
                    : this.ruleForm.homework_scores;
            this.ruleForm.test_scores =
                this.ruleForm.test_condition[0] == '' ? [] : this.ruleForm.test_scores[0] == undefined ? [] : this.ruleForm.test_scores;

            this.$post(this.BASEURL + '/achievement/batch/modify/score', this.ruleForm).then((res) => {
                if (res.code === 200) {
                    this.batchShow = false;
                    this.batchShow1 = false;

                    setTimeout(() => {
                        this.getData(1);
                    }, 1000);

                    this.$message.success(res.msg);

                    //处理数据
                } else {
                    this.$message.error(res.error);
                }
            });
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.batchShow1 = true;
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        dblclick() {
            this.isbatchShow = false;
        },
        dblclick1(row) {
            row.isShow2 = false;
        },

        //批量数据初始化
        initData() {
            //1.年级

            //2.学期
            //3.专业
            this.getTblInfo3();
            //4.函授站点
            this.getTblInfo4();
        },
        getTblInfo3() {
            this.$post(this.BASEURL + '/assets/table/info', {
                tbl_list: [
                    ['id', 'grade,level,name', 'major_base_t'],
                    ['org', 'org_name', 'academy_base_t']
                ],
                state: 1
            }).then((res) => {
                if (res.code === 200) {
                    this.majorList = res.data[0][0];
                } else {
                    console.log(res.error);
                }
            });
        },
        getTblInfo4() {
            this.$post(this.BASEURL + '/assets/table/info', {
                tbl_list: [
                    ['org', 'org_name', 'academy_base_t'],
                    ['id', 'name', 'station_base_t']
                ],
                state: 1
            }).then((res) => {
                if (res.code === 200) {
                    this.stations = res.data[1][0];
                } else {
                    console.log(res.error);
                }
            });
        },

        /**视频 */
        isVC(val) {
            if (val == '大于等于' || val == '小于等于') {
                this.isVD = false;
                this.isVD2 = true;

                this.VIMin = false;
                this.VIMax = false;
            } else if (val == '') {
                (this.isVMin = 0), (this.isVMax = 100), (this.isVMin2 = 0), (this.isVMax2 = 100), (this.ruleForm.video_condition[1] = 0); //条件-视频成绩
                this.ruleForm.video_condition[2] = 0; //条件-视频成绩
                this.isVD = true;
                this.isVD2 = true;

                this.VIMin = true;
                this.VIMax = true;

                this.ruleForm.video_scores = []; //视频成绩
            } else {
                this.isVD = false;
                this.isVD2 = false;

                this.VIMin = false;
                this.VIMax = false;
            }
        },
        isVCdata1(val) {
            this.isVMin2 = val;

            this.ruleForm.video_condition[2] = this.ruleForm.video_condition[1];
        },

        /**作业 */
        isZC(val) {
            if (val == '大于等于' || val == '小于等于') {
                this.isZD = false;
                this.isZD2 = true;

                this.ZIMin = false;
                this.ZIMax = false;
            } else if (val == '') {
                this.isZD = true;
                this.isZD2 = true;

                (this.isZMin = 0), (this.isZMax = 100);
                this.isZMin2 = 0;
                this.isZMax2 = 100;
                this.ruleForm.homework_condition[1] = 0; //条件-视频成绩
                this.ruleForm.homework_condition[2] = 0; //条件-视频成绩
                this.ZIMin = true;
                this.ZIMax = true;

                this.ruleForm.homework_scores = []; //条件-视频成绩
            } else {
                this.isZD = false;
                this.isZD2 = false;

                this.ZIMin = false;
                this.ZIMax = false;
            }
        },
        isZCdata1(val) {
            this.isZMin2 = val;

            this.ruleForm.homework_condition[2] = this.ruleForm.homework_condition[1];
        },

        /**考试 */
        isKC(val) {

            if (val == '大于等于' || val == '小于等于') {
                this.isKD = false;
                this.isKD2 = true;

                this.KIMin = false;
                this.KIMax = false;
            } else if (val == '') {
                this.isKD = true;
                this.isKD2 = true;
                (this.isKMin = 0), (this.isKMax = 100), (this.isKMin2 = 0), (this.isKMax2 = 100), (this.ruleForm.test_condition[1] = 0); //条件-视频成绩
                this.ruleForm.test_condition[2] = 0; //条件-视频成绩
                this.KIMin = true;
                this.KIMax = true;

                this.ruleForm.test_scores = []; //条件-视频成绩
            } else {
                this.isKD = false;
                this.isKD2 = false;

                this.KIMin = false;
                this.KIMax = false;
            }
        },
        isKCdata1(val) {
            this.isKMin2 = val;

            this.ruleForm.test_condition[2] = this.ruleForm.test_condition[1];
        },

        /**结果 */

        // 视频
        Vchange(val) {
            this.VMin2 = val;
            this.ruleForm.video_scores[1] = 0;
        },

        //作业
        Zchange(val) {
            this.ZMin2 = val;
            this.ruleForm.homework_scores[1] = 0;
        },

        //考试
        Kchange(val) {
            this.KMin2 = val;
            this.ruleForm.test_scores[1] = 0;
        },
        focus(event) {
            let input = event.currentTarget;
            //   input.placeholder = "请输入" + val
            input.style.border = '2px solid #409EFF'; //#DCDFE6
        },
        blur(event) {
            this.isbatchShow = true;

            let input = event.currentTarget;

            input.style.border = '1px solid #DCDFE6'; //#
        },
        downloadImportTemp(){
            window.open('https://crjyxspt.zikaoj.com/static/file/tution/导入成绩模板.xlsx')
        },
        Importoflien(){
            this.importVisible = true
        },
        onBeforeUpload(file) {
            let isXlsx = file.name.indexOf('.xlsx') > 0 || file.name.indexOf('.xls') > 0;


            const isLt4M = file.size / 1024 / 1024 < 4;
            if (!isXlsx) {
                this.$message.error('上传文件只能是 xlsx 格式');
                return false;
            } else {
                return file;
            }

        },
        onSuccessUpload(response, file, fileList) {
            this.fileList = [
                {
                    'url': this.STATIC_URL + response.data.url,
                    'name': response.data.name
                }
            ];
        },
        onRemoveUpload(file, fileList) {
            this.fileList = [];
        },
        closeImport() {
            this.error_show = false;
            this.error_html = '';
            this.fileList = [];
            this.$refs.upload.clearFiles();
            this.importVisible = false;
        },
        saveImport() {
            //每次保存前，校验文件是否已经上传
            if (isBlank(this.fileList)) {
                this.$message.error('请上传导入的学生成绩！');
                return false;
            }
            let fileList = this.fileList
            const loading = this.$loading({
                lock: true,//lock的修改符--默认是false
                text: '数据导入中,请耐心等待。',//显示在加载图标下方的加载文案
                spinner: 'el-icon-loading',//自定义加载图标类名
                background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
                target: document.querySelector('#table')//loadin覆盖的dom元素节点
            });
            this.$post(
                this.BASEURL + '/achievement/import/score',
                { 'file_url': fileList[0].url, 'file_name': fileList[0].name }).then((res) => {
                if (res.code === 200) {
                    this.closeImport();
                    this.$message.success(`导入任务开启成功！请到“查看进度”按钮中查看`);
                } else {
                    this.errorList = res.error_list;
                    this.errorShow = true;
                    this.$message.error(res.error);

                }
                loading.close();
            });
        },
    }
};
</script>

<style lang='scss' scoped>
.body {
    button {
        padding: 8px 15px;
        font-size: 14px;
    }
}

.search-box {
    margin-top: $distance;
    margin-bottom: $distance;
    border-radius: $radius;
    padding: 28px 30px;
    background-color: #ffffff;
}

.search-box-line {
    display: flex;
    align-items: center;

    .filter-input {
        width: 20%;
        margin-right: 16px;
        flex-shrink: 0;
    }

    .margin-right-clear {
        margin-right: 0;
    }

    .search-input {
        width: 150px;
        background-color: #20a0ff;
    }

    .title {
        flex-shrink: 0;
        font-size: $title-size;
        line-height: 15px;
        white-space: nowrap;
        color: $title-color;
    }

    & > div {
        display: flex;
        align-items: center;
        text-align: right;
        width: 25%;
        min-width: 200px;

        span {
            min-width: 80px;
            width: 80px;
        }

        .search-input {
            flex-grow: 1;
            //max-width: 260px;
        }

        &:nth-of-type(4) {
            width: 200px;
        }
    }
}

.container {
    .container-btn-line {
        display: flex;
        margin-bottom: 20px;
    }
}

.primary-btn {
    border-color: #409eff;
    color: #409eff;
}

.mot {
    margin: 10px 0;
    font-size: 15px;
}

.top {
    width: 100%;
}

.df {
    display: flex;
}

.df1 {
    display: flex;
    margin: 0 10px;
}

.df2 {
    display: flex;
}

.df3 {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.lien {
    margin: 0 10px;
}

.number {
    width: 150px;
}

.primary-btn {
    border-color: #409eff;
    color: #409eff;
}

/deep/ .el-input-number__increase {
    display: none;
}

/deep/ .el-input-number__decrease {
    display: none;
}

.model-bom {
    width: 100%;

    display: flex;
    justify-content: flex-end;
}

.left-model {
    font-size: 18px;
    margin-left: -15px;
}

// .motV{
//     border-radius: 5px;
//     color: white;
//     background: #409eff;
//     padding:5px 0 ;
// }
// .motZ{
//     border-radius: 5px;
//     color: white;
//     background: #10a779;
//     padding:5px 0 ;
// }
// .motK{
//     border-radius: 5px;
//     color: white;
//     background: #9236dd;
//     padding:5px 0 ;
// }
</style>
